"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createItemDiscountComponent = void 0;
var react_1 = __importDefault(require("react"));
var ItemDiscountStore_1 = __importDefault(require("../../Stores/ItemDiscountStore"));
var ItemDiscountController_1 = __importDefault(require("./ItemDiscountController"));
var createItemDiscountComponent = function (mountReactComponent, itemAdapter, discountService, formatCurrency, discountLabel) {
    var discountStore = new ItemDiscountStore_1.default(itemAdapter.model.discount, itemAdapter.preDiscount(), discountService, formatCurrency);
    return mountReactComponent(react_1.default.createElement(ItemDiscountController_1.default, { discountStore: discountStore, discountLabel: discountLabel }), {
        $init: function (scope) {
            scope.$watch(function () { return itemAdapter.model.discount; }, function () { return discountStore.updateDiscountModelFromAngular(itemAdapter.model.discount); }, true);
            scope.$watch(function () { return itemAdapter.preDiscount(); }, function () { return discountStore.updatePreDiscountFromAngular(itemAdapter.preDiscount()); });
        },
    });
};
exports.createItemDiscountComponent = createItemDiscountComponent;
